export const ALERT_TYPE = {
    ERROR: 'error',
    SUCCESS: 'success',
    INFO: 'info',
};
